var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13360_131402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2557 8.55256L50.1006 66.125C49.8814 66.6952 49.5257 67.2022 49.0651 67.601C48.6044 67.9998 48.053 68.278 47.4599 68.411C46.8667 68.544 46.25 68.5277 45.6646 68.3635C45.0792 68.1992 44.5431 67.8922 44.1039 67.4696L31.6158 55.4537L23.9575 63.1535C23.6991 63.4127 23.3702 63.5889 23.0122 63.6601C22.6543 63.7313 22.2834 63.6943 21.9464 63.5536C21.6094 63.4129 21.3213 63.1749 21.1187 62.8697C20.9161 62.5645 20.8079 62.2057 20.8078 61.8386V45.0535L1.6399 26.6117C1.16432 26.154 0.81899 25.5768 0.639676 24.9398C0.460362 24.3028 0.453577 23.6291 0.620023 22.9885C0.786469 22.348 1.1201 21.7638 1.58636 21.2965C2.05263 20.8292 2.63459 20.4958 3.272 20.3308L67.8912 3.61618C68.5481 3.4469 69.2387 3.46287 69.8873 3.66236C70.5358 3.86184 71.1172 4.23713 71.5676 4.74706C72.0181 5.25699 72.3203 5.88186 72.441 6.55315C72.5617 7.22443 72.4964 7.91619 72.252 8.55256H72.2557ZM63.2718 12.7869L22.7722 39.3482L29.1787 45.5141L63.2718 12.7869Z",
    fill: "#5A8DF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13360_131402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic_send.65e29a937708fb80b2e383255af22143.svg";
export { ForwardRef as ReactComponent };